var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCurrency({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_9961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "#6CDE07"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.375 11.9712C14.375 13.5775 13.0712 14.6438 11.1462 14.8044V16.25H9.8275V14.79C8.52543 14.6432 7.2883 14.1431 6.25 13.3438L7.22 12.015C8.08438 12.6869 8.9025 13.125 9.88812 13.2712V10.4087C7.675 9.85375 6.64437 9.05062 6.64437 7.40062C6.64437 5.82375 7.9325 4.74313 9.8275 4.59688V3.75H11.1462V4.62625C12.177 4.74074 13.1596 5.12346 13.9962 5.73625L13.1469 7.10875C12.48 6.62687 11.7981 6.32 11.0856 6.17437V8.94875C13.39 9.50375 14.375 10.3944 14.375 11.9712ZM9.8875 8.64187V6.07188C8.93312 6.145 8.43313 6.65625 8.43313 7.29875C8.43313 7.91125 8.72062 8.30625 9.88812 8.6425L9.8875 8.64187ZM12.5863 12.0731C12.5863 11.4169 12.2675 11.0225 11.0856 10.6862V13.33C12.0406 13.2562 12.5863 12.7744 12.5863 12.0738V12.0731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_9961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCurrency);
export default __webpack_public_path__ + "static/media/dollar-currency.b1d6b18adff2c31089c45e7882e70194.svg";
export { ForwardRef as ReactComponent };